<template>
  <div class="crop-card-grid">
    <article v-for="item in crops" :key="item.name" class="yield-right-panel crop-card">
      <div class="title">
        <div class="card-label">单品产量预估</div>
        <div class="card-icon">{{ item.icon }}</div>
      </div>
      <div class="info">
        <img :src="item.image" :alt="item.name" class="crop-img" />
        <div class="crop-info">
          <h3>{{ item.name }}</h3>
          <p>{{ item.value }}<span>{{ item.unit }}</span></p>
        </div>
      </div>
      
      
    </article>
  </div>
</template>

<script setup>
const crops = [
  {
    name: "小麦",
    value: "83.8",
    unit: "万吨",
    icon: "麦",
    image: require("@/assets/img/hs.png"),
  },
  {
    name: "玉米",
    value: "41.6",
    unit: "万吨",
    icon: "玉",
    image: require("@/assets/img/hj.png"),
  },
  {
    name: "花生",
    value: "12.4",
    unit: "万吨",
    icon: "花",
    image: require("@/assets/img/lb.png"),
  },
  {
    name: "大豆",
    value: "3.2",
    unit: "万吨",
    icon: "豆",
    image: require("@/assets/img/bc.png"),
  },
];
</script>

<style lang="less" scoped>
@import "../YieldRightShared.less";

.crop-card-grid {
  min-height: 0;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  grid-template-rows: repeat(2, minmax(0, 1fr));
  gap: 30px 36px;
}

.crop-card {
  padding: 34px 36px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.crop-card::before {
  width: 118px;
}

.crop-card::after {
  width: 78px;
}
.title{
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.card-label {
  position: relative;
  z-index: 2;
  color: #f3fffd;
  font-size: 32px;
  font-weight: 700;
  line-height: 30px;
  text-align: left;
}

.card-icon {
  width: 68px;
  height: 68px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #73fff4;
  font-size: 38px;
  font-weight: 800;
  background: radial-gradient(circle at 50% 45%, rgba(0, 177, 156, 0.85), rgba(0, 64, 59, 0.84));
  border: 2px solid rgba(40, 255, 232, 0.54);
  box-shadow: 0 0 20px rgba(40, 255, 232, 0.28);
}
.info{
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}
.crop-img {
  width: 208px;
  height: 208px;
  object-fit: cover;
  border-radius: 18px;
  filter: drop-shadow(0 14px 18px rgba(0, 0, 0, 0.32)) saturate(1.08);
  mix-blend-mode: screen;
}

.crop-info {
  width: 210px;
  color: #ffffff;
  text-align: left;
}

h3 {
  margin: 0 0 24px;
  color: #ffffff;
  font-size: 36px;
  font-weight: 800;
  line-height: 42px;
}

p {
  margin: 0;
  color: #ffffff;
  font-size: 32px;
  font-weight: 800;
  line-height: 38px;
  white-space: nowrap;
}

span {
  margin-left: 2px;
  font-size: 24px;
  font-weight: 700;
}
</style>
